import React from 'react';
//CSS
import styles from './EditableInput.module.css';
import Button from '../Button/Button';
//Components
//Data

type EditableInputProps = {
  value: string;
  onChange?: (newValue: string) => void;
  editAlt?: string;
  saveAlt?: string;
};

const EditableInput = ({ value, onChange, editAlt, saveAlt }: EditableInputProps) => {

    const [isEditing, setIsEditing] = React.useState(false);
    const [newValue, setNewValue] = React.useState(value);

    return (
        isEditing ? (
        <div className={styles.container}>
            <input
            type="text"
            value={newValue}
            onChange={(e) => setNewValue(e.target.value)}
            className={styles.input}
            />
            <Button colour={"#FFF"} size={"IconSmall"} clickHandler={() => {
                setIsEditing(false);
                onChange?.(newValue);
            }}><img src="/img/save.svg" alt={saveAlt || "Save"} /></Button>
        </div>
        ) : (
        <div className={styles.container}>
            <h5>{value}</h5>
            <Button colour={"#FFF"} size={"IconSmall"} clickHandler={() => setIsEditing(true)}><img src="/img/edit.svg" alt={editAlt || "Edit"} /></Button>
        </div>
        )
    );
};

export default EditableInput;